import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Layout from "./components/site/Layout";
import ProtectedRoute from "./components/site/ProtectedRoute";
import Home from "./pages/Home";
import Lakes from "./pages/Lakes";
import Catches from "./pages/Catches";
import Rules from "./pages/Rules";
import Booking from "./pages/Booking";
import Events from "./pages/Events";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Admin from "./pages/Admin";
import Account from "./pages/Account";
import PaymentResult from "./pages/PaymentResult";

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/lakes" element={<Lakes />} />
              <Route path="/catches" element={<Catches />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/events" element={<Events />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              <Route path="/booking/success" element={<PaymentResult mode="success" />} />
              <Route path="/booking/cancel" element={<PaymentResult mode="cancel" />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}
